(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero-c"] && !Shopify.designMode) return;
  try {
    
  class HeroCCarousel extends HTMLElement {
    connectedCallback() {
      this._slides = Array.from(this.querySelectorAll('.hero-c__slide'));
      if (this._slides.length <= 1) return;
      this._current = 0;
      this._timing = (parseFloat(this.dataset.timing) || 5) * 1000;
      this._transition = this.dataset.transition || 'fade';
      this._speed = parseFloat(this.dataset.speed) || 600;
      this._timer = setInterval(() => this._advance(), this._timing);
    }

    _advance() {
      const outgoing = this._slides[this._current];
      this._current = (this._current + 1) % this._slides.length;
      const incoming = this._slides[this._current];

      if (this._transition === 'fade') {
        outgoing.classList.remove('hero-c__slide--active');
        outgoing.setAttribute('aria-hidden', 'true');
        incoming.classList.add('hero-c__slide--active');
        incoming.setAttribute('aria-hidden', 'false');
      } else if (this._transition === 'swipe') {
        outgoing.style.transitionDuration = this._speed + 'ms';
        outgoing.classList.add('hero-c__slide--exit');
        outgoing.classList.remove('hero-c__slide--active');
        outgoing.setAttribute('aria-hidden', 'true');
        incoming.classList.add('hero-c__slide--active');
        incoming.setAttribute('aria-hidden', 'false');
        clearTimeout(this._cleanup);
        this._cleanup = setTimeout(() => {
          outgoing.style.transitionDuration = '';
          outgoing.classList.remove('hero-c__slide--exit');
        }, this._speed + 100);
      } else {
        outgoing.classList.add('hero-c__slide--exit');
        outgoing.classList.remove('hero-c__slide--active');
        outgoing.setAttribute('aria-hidden', 'true');
        incoming.classList.add('hero-c__slide--active');
        incoming.setAttribute('aria-hidden', 'false');
        clearTimeout(this._cleanup);
        this._cleanup = setTimeout(() => outgoing.classList.remove('hero-c__slide--exit'), this._speed + 100);
      }
    }

    disconnectedCallback() {
      clearInterval(this._timer);
      clearTimeout(this._cleanup);
    }
  }

  if (!customElements.get('hero-c-carousel')) {
    customElements.define('hero-c-carousel', HeroCCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
